import { render, staticRenderFns } from "./SelectValue.vue?vue&type=template&id=4fdb697f&scoped=true&"
import script from "./SelectValue.vue?vue&type=script&lang=js&"
export * from "./SelectValue.vue?vue&type=script&lang=js&"
import style0 from "./SelectValue.vue?vue&type=style&index=0&id=4fdb697f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb697f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
